<template>
  <div class="share">
    <div class="container">
      <div class="download_top" @click="downloadHandle()">
        <div class="left">
          <div class="logo_icon"></div>
          <div class="logo_info">
            <div class="logo_title"></div>
            <p>MINE THE WISDOM,READ TO EXCEED</p>
          </div>
        </div>
        <div class="right">
          <div class="download_btn">Download</div>
        </div>
      </div>
      <div class="share_content_box">
        <div class="share_content">
          <div class="share_content_item">
            <div class="share_detail">
              <div class="author">
                <div class="avatar_img">
                  <img :src="detailData.author_info?.author_head_pic || detailData.domain_image" alt="" />
                </div>
                <div class="author_info">
                  <div class="author_name">{{ detailData.author_info?.author_name || detailData.domain_label }}</div>
                  <div class="recommend_info">
                    <div class="read_txt">{{ detailData.read_time }}</div>
                    <div class="publish_time">{{ detailData.publish_time }}</div>
                    <div class="hot">{{ detailData.total_score }}</div>
                  </div>
                </div>
              </div>
              <div class="share_title" v-if="type !== 'long_tweet'" v-html="title"></div>
              <template v-if="type !== 'long_tweet'">
                <div class="markdown_content" v-html="content"></div>
              </template>
              <template v-else>
                <div class="twitter_block" v-for="(item, index) in content" :key="index">
                  <div class="left">
                    <div class="point"></div>
                    <div class="line" v-if="index < content.length - 1"></div>
                  </div>
                  <div class="right">
                    <div class="markdown_content" v-html="item"></div>
                  </div>
                </div>
              </template>
              <div v-if="full_text !== 'true'" class="content_mask"></div>
            </div>
            <div class="share_content_bar" @click="jumpOriginal"></div>
          </div>
        </div>
        <div class="share_content" v-for="(item, index) in recommendList" :key="index" @click="downloadHandle">
          <div class="recommend_list_title" v-if="index === 0">Recommend to you</div>
          <div class="recommend_item">
            <div class="left" v-if="item.image">
              <img :src="item.image" alt="" />
            </div>
            <div class="right" :class="{ no_image: !item.image }">
              <div class="author">
                <div class="avatar_img">
                  <img :src="item.domain_image" alt="" />
                </div>
                <div class="author_info">
                  <div class="author_name">{{ item.domain_label }}</div>
                  <div class="recommend_info">
                    <div class="read_txt">{{ item.read_time }}</div>
                    <div class="publish_time">{{ item.publish_time }}</div>
                    <div class="hot">{{ item.total_score }}</div>
                  </div>
                </div>
              </div>
              <div class="recommend_title" v-if="item.type !== 'long_tweet'" v-html="item.title"></div>
              <template v-else>
                <div class="twitter_block" v-for="(title, i) in item.title" :key="i">
                  <div class="left">
                    <div class="point"></div>
                    <div class="line"></div>
                  </div>
                  <div class="right">
                    <div class="markdown_content" v-html="title"></div>
                  </div>
                </div>
              </template>
              <div class="thread">
                <div class="thread_points">
                  <div class="thread_point"></div>
                  <div class="thread_point"></div>
                  <div class="thread_point"></div>
                </div>
                Show this thread
              </div>
              <div class="tags">
                <template v-for="(tag, i) in item.topics" :key="i">
                  <div class="tag" v-if="i < 2">{{ tag.label }}</div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="share_bottom" @click="openApp">
        <div class="open_btn"></div>
      </div>
    </div>
  </div>
</template>

<script>
import showdown from 'showdown';
import { contentDetail, relatedRec } from '../../apis/share';
import { isIOS, isAndroid } from '../../utils/env';
import qs from 'qs';
const converter = new showdown.Converter({ smoothLivePreview: true, simpleLineBreaks: true });

export default {
  name: 'share-page',
  data () {
    return {
      type: '',
      title: '',
      content: '',
      recommendList: [],
      detailData: {},
      contentId: '',
      lang: '',
      full_text: '',
      externalUrl: '',
    };
  },
  created () {
    const querObj = qs.parse(location.search, { ignoreQueryPrefix: true });
    this.contentId = querObj.content_id;
    this.lang = querObj.lang_type;
    this.full_text = querObj.full_text || 'true';
    contentDetail({
      content_id: querObj.content_id * 1,
      recall_lang_type: querObj.lang_type,
    }).then(this.contentHandle).catch(res => {
      console.log(res, 'err res')
      if (res.response.data.data === null) {
        contentDetail({
          content_id: querObj.content_id * 1,
        }).then(this.contentHandle)
      }
    });
    relatedRec({
      content_id: querObj.content_id * 1,
      recall_lang_type: querObj.lang_type,
    }).then((res) => {
      res.data.forEach(item => {
        item.title = this.fromatTitle(item);
      });
      this.recommendList = res.data;
    });
  },
  methods: {
    contentHandle (res) {
      console.log(this.full_text);
      this.detailData = res.data;
      const type = res.data.type;
      this.type = type;
      if (type === 'long_tweet') {
        this.title = converter.makeHtml(JSON.parse(res.data.title)[0]);
        this.externalUrl = res.data.external_url;
        const content = JSON.parse(res.data.content_body).map(str => {
          return converter.makeHtml(str);
        });
        console.log(content, 'content')
        if (this.full_text === 'true') {
          this.content = content;
        } else {
          this.content = content.substring(0, 300);
        }
      } else {
        this.title = res.data.title;
        this.externalUrl = res.data.external_url;
        if (this.full_text === 'true') {
          this.content = converter.makeHtml(res.data.content_body);
        } else {
          this.content = converter.makeHtml(res.data.content_body.substring(0, 300));
        }
      }
    },
    openApp () {
      let openUrl = `readon://me.readon.app/content/detail?content_id=${this.contentId}&lang=${this.lang}`;
      if (isIOS()) {
        let aLink = document.createElement('a');
        aLink.setAttribute('ahw', '1');
        aLink.href = openUrl;
        document.body.appendChild(aLink);
        aLink.click();
      } else {
        try {
          window.location = openUrl; //安卓兄弟可以给你
        } catch (e) {
          this.downloadHandle();
        }
        setTimeout(() => {
          this.downloadHandle();
        }, 2000);
      }
    },
    downloadHandle () {
      if (isIOS()) {
        window.location.href = 'https://apps.apple.com/us/app/readon-dao/id1635013649';
      } else if (isAndroid()) {
        window.location.href = 'https://play.google.com/store/apps/details?id=me.readon.app';
      } else {
        window.location.href = 'https://readon.me/download';
      }
    },
    jumpOriginal () {
      window.location.href = this.externalUrl;
    },
    fromatTitle (item) {
      console.log(item)
      if (item.type === 'long_tweet') {
        return JSON.parse(item.title).map(str => {
          return converter.makeHtml(str);
        });
      } else {
        return item.title;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@rem: 75rem;

.recommend_item {
  display: flex;

  .left {
    width: 100 * 2 / @rem;
    height: 132 * 2 / @rem;
    border-radius: 10 * 2 / @rem;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .right {
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 0 0 0 12 * 2 / @rem;

    &.no_image {
      .recommend_title {
        width: auto;
      }
    }

    .tags {
      display: flex;
    }

    .tag {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 12 * 2 / @rem 0 0;
      padding: 6 * 2 / @rem;
      background: rgba(109, 221, 137, 0.2);
      border-radius: 4 * 2 / @rem;
      font-family: 'PingFang SC';
      font-style: normal;
      font-weight: 400;
      font-size: 12 * 2 / @rem;
      line-height: 120%;
      color: rgba(255, 255, 255, 0.8);
    }
  }
}

.author {
  display: flex;

  .avatar_img {
    margin: 0 6 * 2 / @rem 0 0;
    width: 28 * 2 / @rem;
    height: 28 * 2 / @rem;
    border-radius: 50%;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .author_info {
    display: flex;
    flex-direction: column;
    justify-content: center;

    .author_name {
      font-family: 'PingFang SC';
      font-style: normal;
      font-weight: 500;
      font-size: 12 * 2 / @rem;
      line-height: 120%;
      color: rgba(255, 255, 255, 0.92);
    }

    .recommend_info {
      display: flex;
      justify-content: space-between;
      font-family: 'PingFang SC';
      font-style: normal;
      font-weight: 400;
      font-size: 10 * 2 / @rem;
      line-height: 120%;
      color: rgba(255, 255, 255, 0.4);

      .read_txt {}

      .publish_time {
        margin: 0 0 0 6 * 2 / @rem;
      }

      .hot {
        display: inline-block;
        margin: 0 0 0 6 * 2 / @rem;
        padding: 0 0 0 12 * 2 / @rem;
        background: url('../../assets/hot.svg') no-repeat left center;
        background-size: 10 * 2 / @rem 10 * 2 / @rem;

        &.recommend {
          margin: 0 0 0 6 * 2 / @rem;
          padding: 0 0 0 16 * 2 / @rem;
        }
      }
    }
  }
}

.share_title {
  padding: 26 * 2 / @rem 0 6 * 2 / @rem 0;
  font-family: 'Georgia';
  font-style: normal;
  font-weight: 700;
  font-size: 24 * 2 / @rem;
  line-height: 36 * 2 / @rem;
  letter-spacing: 0.25 * 2 / @rem;
  color: rgba(255, 255, 255, 0.92);
}

.share {
  height: 100vh;
  background: #00182a;
  text-align: initial;
}

.logo_icon {
  width: 40 * 2 / @rem;
  height: 40 * 2 / @rem;
  background: url('../../assets/logo_border.svg') no-repeat center;
  background-size: contain;
}

.container {
  display: flex;
  flex-direction: column;
  margin: auto;
  height: 100%;
  max-width: 375 * 2 / @rem;
}

.logo_info {
  display: flex;
  padding: 0 0 0 10 * 2 / @rem;
  flex-direction: column;
  justify-content: space-between;
  height: 36 * 2 / @rem;

  p {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 10 * 2 / @rem;
    line-height: 14 * 2 / @rem;
    color: rgba(255, 255, 255, 0.4);
    -webkit-text-size-adjust: none;
  }
}

.logo_title {
  width: 64 * 2 / @rem;
  height: 13 * 2 / @rem;
  background: url('../../assets/readon_title.svg') no-repeat;
  background-size: contain;
}

.download_btn {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 24 * 2 / @rem 0 0;
  width: 78 * 2 / @rem;
  height: 28 * 2 / @rem;
  background: #55bb6e;
  border-radius: 14 * 2 / @rem;
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 500;
  font-size: 12 * 2 / @rem;
  line-height: 120%;
  color: rgba(255, 255, 255, 0.92);
}

.download_top {
  display: flex;
  justify-content: space-between;
  top: 0;
  width: 100%;
  height: 70 * 2 / @rem;
  background: #091923;

  .left {
    display: flex;
    padding: 0 0 0 24 * 2 / @rem;
    align-items: center;
    height: 100%;
  }

  .right {
    display: flex;
    flex: 1;
    justify-content: flex-end;
    align-items: center;
    height: 100%;
  }
}

.share_content_box {
  flex: 1;
  overflow-y: auto;
}

.share_content {
  margin: 0 0 8 * 2 / @rem 0;
  padding: 30 * 2 / @rem 24 * 2 / @rem 30 * 2 / @rem 24 * 2 / @rem;
  background: #0e2330;
  box-sizing: border-box;
}

:deep(.markdown_content) {
  background: #0e2330;
  box-sizing: border-box;
  color: rgba(255, 255, 255, 0.92);

  img {
    width: 100%;
  }

  h1 {
    padding: 0 0 20 * 2 / @rem 0;
    font-family: 'Georgia';
    font-style: normal;
    font-weight: 700;
    font-size: 24 * 2 / @rem;
    line-height: 36 * 2 / @rem;
    letter-spacing: 0.25 * 2 / @rem;
    color: rgba(255, 255, 255, 0.92);
  }

  p {
    padding: 0 0 18 * 2 / @rem 0;
    font-family: 'Georgia';
    font-style: normal;
    font-weight: 400;
    font-size: 16 * 2 / @rem;
    line-height: 30 * 2 / @rem;
    color: rgba(255, 255, 255, 0.92);
  }
}

.share_content_bar {
  display: flex;
  margin: auto;
  justify-content: space-between;
  width: 327 * 2 / @rem;
  height: 32 * 2 / @rem;
  background: url('../../assets/s_content_bar.svg') no-repeat center;
  background-size: contain;
}

.share_content_btns {
  display: flex;
  align-items: center;
  height: 100%;
}

.share_bottom {
  position: fixed;
  display: flex;
  bottom: 60 * 2 / @rem;
  justify-content: center;
  align-items: center;
  left: 50%;
  // padding-bottom: constant(safe-area-inset-bottom); //兼容 IOS<11.2
  // padding-bottom: env(safe-area-inset-bottom); //兼容 IOS>11.2
  transform: translate(-50%, 0);
}

.open_btn {
  width: 150 * 2 / @rem;
  height: 36 * 2 / @rem;
  background: url('../../assets/s_open_btn.svg') no-repeat center;
  background-size: contain;
}

.recommend_list_title {
  padding: 0 0 30 * 2 / @rem 0;
  font-family: 'Georgia';
  font-style: normal;
  font-weight: 700;
  font-size: 24 * 2 / @rem;
  line-height: 36 * 2 / @rem;
  letter-spacing: 0.25 * 2 / @rem;
  color: rgba(255, 255, 255, 0.92);
}

.share_detail {
  position: relative;

  .content_mask {
    position: absolute;
    width: 100%;
    height: 166 * 2 / @rem;
    left: 0;
    bottom: 0;
    background: linear-gradient(0deg, #0e2330 43.48%, rgba(14, 35, 48, 0.33) 96.98%);
  }
}

.recommend_title {
  margin: 0 0 8 * 2 / @rem 0;
  padding: 14 * 2 / @rem 0 0 0;
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 600;
  font-size: 16 * 2 / @rem;
  line-height: 120%;
  text-transform: capitalize;
  color: rgba(255, 255, 255, 0.92);
  width: 211 * 2 / @rem;
  height: 50 * 2 / @rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;


}

.twitter_block {
  display: flex;
  padding: 10*2/@rem 0 0 0;

  .left {
    display: flex;
    margin: 0 6*2/@rem 0 0;
    width: 20 * 2/@rem;
    min-height: 100%;
    flex-direction: column;
    flex-shrink: 0;
    align-items: center;
  }

  .point {
    margin: 10 * 2/@rem 0 10 * 2/@rem 0;
    width: 8 * 2/@rem;
    height: 8 * 2/@rem;
    background: rgba(255, 255, 255, 0.40);
    border-radius: 50%;
  }

  .line {
    width: 1*2/@rem;
    margin: 5*2/@rem 0 2*2/@rem 0;
    flex: 1;
    border-right: 1*2/@rem solid rgba(255, 255, 255, 0.2);
  }
}

.thread {
  display: flex;
  align-items: center;
  font-family: 'Georgia';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: 0.04em;
  color: rgba(255, 255, 255, 0.6);
}

.thread_points {
  display: flex;
  margin: 0 21 * 2 / @rem 0 10 * 2 / @rem;
  padding: 6 * 2 / @rem 0;
  justify-content: space-between;
  flex-direction: column;
  width: 2 * 2 / @rem;
  height: 100%;
  box-sizing: border-box;
}

.thread_point {
  margin: 1 * 2 / @rem 0;
  width: 2 * 2 / @rem;
  height: 2 * 2 / @rem;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 50%;
}
</style>
<style lang="less">
@media screen and (min-width: 450px) {
  html {
    font-size: 45px !important;
  }
}
</style>
